import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { cls } from "cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { Product, SelectedProduct } from "~/common/Store/models/ProductListing";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { RootState, UserState } from "~/common/Store/models/RootReadonly";
import AddToCartButton from "~/productListing/ProductBox/AddToCart";
import "../../Styles/FlashDealItem.less";

interface Props {
  product: Product;
  salePrice: number;
  couponCode: string;
  user: UserState;
  countdownDisplay: string;
  hasUpcomingDeal?: boolean;
}

const ActiveFlashDeal = ({
  product,
  user,
  salePrice,
  couponCode,
  hasUpcomingDeal,
}: Props) => {
  const [selectedProduct, setSelectedProduct] = useState<SelectedProduct>({
    ...product,
    activeSale: product.price.displaySalePrice,
    isOutlet: product.outletAttributes && product.outletAttributes.isOutlet,
  });

  useEffect(() => {
    setSelectedProduct({
      ...product,
      activeSale: product.price.displaySalePrice,
      isOutlet: product.outletAttributes && product.outletAttributes.isOutlet,
    });
  }, [product]);

  return (
    <div id="active-flash-deal" className={cls("flex", "space-x-4", "w-full")}>
      <a
        href={product.link}
        className={cls("rounded")}
        title={product.description}
      >
        <NoScriptLazyImage
          className={cls("rounded")}
          alt={product.description}
          src={product.primaryImagePath}
          data-src={product.primaryImagePath}
        />
      </a>
      <div
        className={cls(
          "flex",
          "flex-col",
          "flex-auto",
          "justify-between",
          hasUpcomingDeal ? "w-min" : "w-auto",
        )}
      >
        <div className={cls("flex", "flex-col")}>
          <a
            href={product.link}
            title={product.description}
            className={`${cls(
              "text-base",
              "md:text-lg",
              "lg:text-xl",
              "font-bold",
              "text-green-600",
              "mb-1",
              "hover:text-green-800",
              "transition",
              "duration-150",
              "ease-in",
            )} product-description`}
            style={{ lineHeight: 1 }}
            data-testid="activeFlashDealDescription"
          >
            {product.description}
          </a>
          <p className={cls("mb-0", "text-xl", "font-bold", "text-red-500")}>
            {` ${formatAsCurrency.formatIfUndefined(salePrice)}`}
            {selectedProduct.unitOfMeasure && (
              <span
                className={cls("text-gray-900", "font-semibold", "text-sm")}
              >
                {`/${selectedProduct.unitOfMeasure}`}
              </span>
            )}
          </p>
          {selectedProduct.activeSale && (
            <div className={cls("relative", "mb-2", "-mt-1", "leading-none")}>
              <span
                className={cls(
                  "inline",
                  "font-normal",
                  "m-0",
                  "px-0",
                  "text-center",
                  "text-gray-800",
                  "uppercase",
                  "line-through",
                  "line-through-red-500",
                  "text-sm",
                )}
              >
                {` ${formatAsCurrency.formatIfUndefined(
                  selectedProduct.price.price,
                )} `}
              </span>
            </div>
          )}
        </div>
        <div
          className={cls(
            "flex",
            "flex-wrap",
            "justify-between",
            "items-end",
            "gap-2",
            "w-full",
          )}
        >
          <div className={cls("w-32", "mr-2")}>
            <AddToCartButton
              {...{
                product,
                user,
                selectedProduct,
                setSelectedProduct,
                isCarouselProductBox: true,
              }}
              discountCode={couponCode}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const mapStateToProps = (state: RootState) => ({ user: state.user });

export default connect(mapStateToProps)(ActiveFlashDeal);
